import * as angular from 'angular';

class ProductsController {
  private ProductsService: any;
  private Services: any;
  private toastr: any;
  private ngDialog: any;
  private editing: any;
  private productsList: any;
  private productGroupsList: any;
  private productToEdit: any;
  private productToEditName: any;
  private servicesList: any;
  private selectedService: any;
  private searchQuery: any;
  private questionnaires: any;
  private shipment_options: any;
  private input_shipment_options: any;
  private output_shipment_options: any;
  constructor(ProductsService: any, QuestionnaireService: any, toastr: any, ngDialog: any, Services: any) {
    Object.assign(this, {
      ProductsService,
      QuestionnaireService,
      Services,
      toastr,
      ngDialog,
      editing: false,
      productsList: [],
      productToEdit: {},
      productToEditName: '',
      servicesList: [],
      selectedService: {},
      searchQuery: '',
      questionnaires: [],
      shipment_options: [
        { label: 'Standard', value: 'mail_order', selected: false },
        { label: 'Special Delivery', value: 'special_delivery', selected: false },
        { label: 'Pick Up', value: 'pick_up', selected: false },
      ],
      input_shipment_options: [],
      output_shipment_options: [],
    });

    this.getProducts();
    this.getServices();
  }

  getProducts() {
    this.ProductsService.getProducts()
    // @ts-ignore
      .then(({ data }) => {
        this.productsList = data;
      })
      .catch((err: { data: { error_message: any; }; }) => {
        this.toastr.error(err.data.error_message);
      });
  }

  getServices() {
    this.Services.list()
    // @ts-ignore
      .then(({ data }) => {
        data.data.sort((a: { name: number; }, b: { name: number; }) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });

        data.data.forEach((service: any) => {
          if (service.children && service.children.length) {
            service.children.forEach((child: { code_name: string; code: any; name: any; }) => {
              child.code_name = `${child.code } - ${ child.name}`;
              this.servicesList.push(child);
            });
          } else {
            service.code_name = `${service.code } - ${ service.name}`;
            this.servicesList.push(service);
          }
        });

        this.servicesList = this.servicesList.map((item: { code: any; }) => {
          return { ...item, service_code: item.code };
        });

        this.servicesList.unshift({ code_name: 'Please select a service', service_code: 'Please select a service' });
        this.selectedService = this.servicesList[0];
      })
      .catch((err: any) => {
        this.toastr.error(`Error getting services: ${ JSON.stringify(err)}`);
      });
  }

  getQuestionnaires() {
    if (this.questionnaires.length > 1) {
      return;
    }
    // @ts-ignore
    this.QuestionnaireService.list(this.productToEdit.service_code)
    // @ts-ignore
      .then(({ data }) => {
        const { data: questionnaires } = data;
        this.questionnaires = questionnaires
    // @ts-ignore
          .filter(questionnaire => questionnaire.phase === "published")
    // @ts-ignore
          .map(questionnaire => ({
            ...questionnaire,
            label: `${questionnaire.name} #${questionnaire.id}`,
          }));
      });
  }

  getProductsByCode(code: any) {
    this.ProductsService.getProductsByCode(code)
    // @ts-ignore
      .then(({ data }) => {
        this.productsList = data;
      })
      .catch((err: { data: { error_message: any; }; }) => {
        this.toastr.error(err.data.error_message);
      });
  }

  changeService() {
    this.getProductsByCode(this.selectedService.code);
  }

  resetFilters() {
    this.searchQuery = '';
    this.selectedService = this.servicesList[0];
    this.getProducts();
  }

  editProduct(product: {
    special_delivery: any;
    pick_up: any;
    mail_order: any;
    name: any; service_code: any; }) {
    this.editing = true;
    this.productToEdit = JSON.parse(JSON.stringify(product));
    this.input_shipment_options = this.shipment_options.filter((option: { value: string; }) => (
        (option.value === 'mail_order' && !!product.mail_order.pharmacy_option_id) ||
        (option.value === 'special_delivery' && !!product.special_delivery.pharmacy_option_id) ||
        (option.value === 'pick_up' && !!product.pick_up.pharmacy_option_id)
      ));
    this.input_shipment_options.forEach((option: { selected: boolean; value: string | number; }) => {
      // @ts-ignore
      option.selected = !!product[option.value].visible_to_patient;
    });
    this.productToEditName = product.name;
    this.setDefaultQuestionnaire(product);
  }

  setDefaultQuestionnaire(product: any) {
    const defaultQuestionnaire = {
      label: `${product.questionnaire_name} #${product.questionnaire_id}`,
      id: product.questionnaire_id,
    };
    this.questionnaires = [defaultQuestionnaire];
  }

  cancelEditing() {
    this.editing = false;
    this.productToEdit = {};
    this.productToEditName = '';
    this.questionnaires = [];
  }

  saveChanges() {
    const config = {
      template: 'app/components/modals/confirm.tpl.html',
      data: {
        title: 'Confirm editing product',
        content: `Are you sure you want to change "${this.productToEditName}"?`,
      },
    };

    this.ngDialog.openConfirm(config)
      .then(() => this.updateProduct());
  }

  serviceUpdated() {
    this.questionnaires = [];
    this.getQuestionnaires();
  }

  updateProduct() {
    const payload = {
      code: this.productToEdit.code,
      service_code: this.productToEdit.service_code,
      name: this.productToEdit.name,
      quantity: this.productToEdit.quantity ? this.productToEdit.quantity : '',
      price: this.productToEdit.price,
      featured_position: this.productToEdit.featured_position,
      visible: this.productToEdit.visible,
      out_of_stock: this.productToEdit.out_of_stock,
      default_medication_code: this.productToEdit.default_medication.code,
      questionnaire_id: this.productToEdit.questionnaire_id,
      mail_order_pharmacy_option_id: this.productToEdit.mail_order.pharmacy_option_id,
      // @ts-ignore
      mail_order_visible_to_patient: +this.output_shipment_options.some(({ value }) => value === 'mail_order'),
      special_delivery_pharmacy_option_id: this.productToEdit.special_delivery.pharmacy_option_id,
      // @ts-ignore
      special_delivery_visible_to_patient: +this.output_shipment_options.some(({ value }) => value === 'special_delivery'),
      pick_up_pharmacy_option_id: this.productToEdit.pick_up.pharmacy_option_id,
      // @ts-ignore
      pick_up_visible_to_patient: +this.output_shipment_options.some(({ value }) => value === 'pick_up'),
    };

    this.ProductsService.editProduct(this.productToEdit.code, payload)
      .then(() => {
        this.toastr.success(`"${this.productToEdit.name}" updated successfully`);

        this.cancelEditing();
        if (this.selectedService.code) {
          this.getProductsByCode(this.selectedService.code);
        } else {
          this.getProducts();
        }
      })
      .catch((err: { data: { error_message: any; }; }) => {
        this.toastr.error(err.data.error_message);
      });
  }

  clone() {
    const this2 = this;
    this2.openCloneProductModal((data: any) => {
      if (data) {
        this.ProductsService.cloneProduct(this.productToEdit.code, {
          code: data.code,
          sku: data.SKU,
          // @ts-ignore
        }).then(({ data }) => {
          this.productToEditName = data.name;
          this.productToEdit = data;
          this.setDefaultQuestionnaire(data);
          // @ts-ignore
        }).catch(({ data }) => {
          let error_message = data.error_message;
          //  If error message can't be found, display the status code and display via toastr
          if (!error_message) {
            error_message = data.status;
          }
          this.toastr.error(error_message);
        });
      }
    });
  }

  openCloneProductModal(callback: any) {
    return this.ngDialog.open({
      templateUrl: 'app/components/clone-product/clone-product.html',
      showClose: false,
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,

      controller: 'CloneProductController',
      controllerAs: '$ctrl',
      preCloseCallback(res: any) {
        if (res) {
          return callback(res);
        }
        return callback(false);
      },
    });
  }
}
ProductsController.$inject = ["ProductsService", 'QuestionnaireService', 'toastr', 'ngDialog', 'Services'];
angular.module('pims').controller('ProductsController', ProductsController);
